<template>
  <div class="css-jl1qws new-order-dialog d-dialog" @click.stop="closeDialog">
    <div class="sc-bdVaJa keQvRI"></div>
    <slide-x-left-transition>
      <div class="css-wgk558" @click.stop=";">
        <div class="css-7bwbxg">
          <div class="d-content">
            <header class="c">
              <a href="javascript:void(0);;" class="c a-btn" title="关闭" @click.stop="closeDialog">
                <img src="../assets/imgs/fail1.svg" width="24" height="24">
              </a>
            </header>
            <div class="main main-body">
              <div class="wx-users" v-loading="loading.data">
                <div class="wx-user" v-for="(item,i) in users" :key="i" @click="wxid = item.wechatId; clearTotalUnread(i)" :class="{a:wxid===item.wechatId}">
                  <div class="wx-user-l">
                    <el-badge :value="item.totalUnread || null" class="item">
                      <div class="wx-user-avatar">
                        <wechat-avatar :url="item.profile"></wechat-avatar>
                      </div>
                    </el-badge>
                    <div class="wx-user-m">
                      <div class="wx-user-name">{{ item.name }}</div>
                      <div class="wx-user-last-msg">{{ item.lastMsg }}</div>
                    </div>
                  </div>
                  <div class="wx-user-last-time">{{ item.lastOnlineTime | time }}</div>
                </div>
              </div>
              <Wechat :wechat-id="wxid" ref="wechat"></Wechat>
            </div>
          </div>
        </div>
      </div>
    </slide-x-left-transition>
  </div>
</template>

<script>
import Wechat from "@/components/Wechat";
import WechatAvatar from "@/components/WechatAvatar";
import appConfig from "@/app-config";
import mySocket from "@/components/mySocket";
import wechatMsgHandle from "@/components/WechatMsgHandle";

export default {
  name: "WechatDialog",
  components: {Wechat, WechatAvatar},
  data () {
    return {
      users: [],
      wxid: null,
      loading: {
        data: false
      }
    }
  },
  filters: {
    time (t) {
      let d = new Date(t)
      let currentStamp = new Date().setHours(0, 0, 0, 0)
      let ymd = d.setHours(0, 0, 0, 0)
      if (ymd === currentStamp)
        return new Date(t).Format('HH:mm')
      return new Date(t).Format('MM-dd')
    }
  },
  methods: {
    clearTotalUnread (i) {
      this.users[i].totalUnread = 0
    },
    closeDialog () {
      this.$router.push('/')
    },
    loadData () {
      if (this.loading.data)
        return
      this.loading.data = true
      this.$get('/wx/users', {wechatId: appConfig.wxid}, res => {
        res.forEach(item => item.lastMsg = wechatMsgHandle(item.lastMsg))
        this.users = res
        this.loading.data = false
      })
    }
  },
  created () {
    let self = this
    window._mySocket = mySocket.create({
      onmessage (data) {
        if (data.type === 0)
          self.loadData()
      }
    })
    this.loadData()
  },
  beforeDestroy () {
    window._mySocket.close()
  }
}
</script>
<style>
.el-badge__content.is-fixed {
  right: 22px !important;
}

.msg-list {
  margin-top: unset !important;
  max-height: unset !important;
  padding: 20px !important;
}

.wx-user-avatar .p {
  display: flex;
}
</style>
<style scoped>

.d-content .main-body {
  max-height: calc(100% - 106px);
}

.wx-user-avatar {
  padding-right: 10px;
}

.main-body {
  padding: 20px;
}

.wx-user-l {
  display: flex;
  width: calc(100% - 37px);
}

.wx-users {
  min-width: 210px;
  max-width: 210px;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: unset;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.wx-users::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.wx-user {
  padding: 12px 15px 12px 10px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  border-radius: 2px;
  position: relative;
}

.wx-user.a::after {
  content: ' ';
  position: absolute;
  right: 0;
  background: rgb(107, 119, 140);
  top: 0;
  height: 100%;
  width: 3px;
  transform: translateX(0px);
  border-radius: 2px;
}

.wx-user:hover {
  background-color: #cccccc40;
}

.wx-user-last-msg, .wx-user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wx-user-last-msg {
  font-size: 10px;
  color: #ccc;
}

.wx-user-m {
  width: calc(100% - 45px);
}

.wx-user-last-time {
  font-size: 10px;
  color: #ccc;
}
</style>